module.exports = "<section class=\"active-filters clearfix\">\r\n    <span class=\"muted\"></span>\r\n    <span *ngFor=\"let item of items\" class=\"muted\">{{item}}<small class=\"muted\"> | </small></span>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/publishers-selected-items.component.html
// module id = ./src/app/shared/publishers-selected-items.component.html
// module chunks = main